import {AfterViewInit, Component} from '@angular/core';
import {sensor} from "../../models/sensor";
import {fade} from "../../models/fade";
import {grupo} from "../../models/grupo";
import {Localiser} from "../../services/localiser";
import {MatDialog} from "@angular/material/dialog";
import {GrupoService} from "../../services/grupo.service";
import {FadeService} from "../../services/fade.service";
import { FadeTimesService } from 'src/app/services/fade-times.service';
import { fadeTime } from "../../models/fadeTime";
import {ListaFadesComponent} from "./lista-fades/lista-fades.component";
import {ListaGruposComponent} from "./lista-grupos/lista-grupos.component";
import {ProyectoService} from "../../services/proyecto.service";
import {Navigation} from "../../services/navigation.service";
import {plano} from "../../models/plano";
import {luminaria} from "../../models/luminaria";
import {PlanoService} from "../../services/plano.service";
import {LuminariaService} from "../../services/luminaria.service";

@Component({
  selector: 'app-fade',
  templateUrl: './fade.component.html',
  styleUrls: ['./fade.component.css']
})
export class FadeComponent implements AfterViewInit {

  sensores: sensor[];
  fades: fade[];
  fadeSelect: fade;
  fadeTimes: fadeTime[];
  selectedFadeInTimeNominalValue: number = 0;
  selectedFadeOutTimeNominalValue: number = 0;

  planoSelected: plano = undefined;
  grupoSelected: grupo = undefined;
  planos: Array<plano> = [];
  grupos: Array<grupo> = [];
  luminarias: Array<luminaria> = [];
  luminariasReal: Array<luminaria> = [];

  searcherLuminarias: string = "";

  constructor(public localiser: Localiser, public matDialog: MatDialog, private grupoService: GrupoService,
              private fadeService: FadeService, private fadeTimesService: FadeTimesService, private planoService: PlanoService, public proyectoService: ProyectoService,
              public navigation: Navigation, public luminariaService: LuminariaService) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("fade");
      this.toLocations();
    } else {
      proyectoService.setLastPage("fade")
    }
  }

  ngAfterViewInit(): void {
    this.init();
  }

  init() {
    this.planoSelected = undefined;
    this.grupoSelected = undefined;
    this.getPlanos();
    this.getFades();
    this.getGrupos();
    this.getLuminarias();
    this.getFadeTimes();
  }

  getPlanos() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.planos = <Array<plano>> result;
    });
  }

  getFades() {
    this.fadeService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.fades = <Array<fade>> result;
    });
  }

  getGrupos() {
    this.grupoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.grupos = <Array<grupo>> result;
    });
  }

  getLuminarias() {
    this.luminariaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.luminariasReal = <Array<luminaria>> result;
      this.luminarias = this.luminariasReal;
      this.loadLuminarias();
    });
  }

  sendAllFades() {
    this.fadeService.sendAllFades();
  }


  listaFades() {
    let dialog = this.matDialog.open(ListaFadesComponent, {
      width: '92%',
      height: '88%'
    });

    // limpiamos el fade select para que no se muestren datos en pantalla al cerrar el popup
    this.fadeSelect = undefined;

    dialog.afterClosed().subscribe(() => { this.init() } );
  }

  listaGrupos() {
    let dialog = this.matDialog.open(ListaGruposComponent, {
      width: '100%',
      height: '85%',
      maxWidth: '90vw'
    });

    dialog.afterClosed().subscribe(() => { this.init() } );
  }

  selectFade(event) {
    if (event.value == '-1') {
      this.fadeSelect = undefined;
    } else {
      this.fadeSelect = this.fades.find(fade => fade.id == event.value.id);

      // cruzar las dos tablas para obtener el fade time nominal
      const fadeInTimeAux = this.fadeTimes.find(fadeTime => fadeTime.fadeTime === parseInt(this.fadeSelect.fade_in));
      if (fadeInTimeAux) {
        this.selectedFadeInTimeNominalValue = fadeInTimeAux.nominalValue;
      } else {
        console.error('No se encontró ninguna coincidencia con fadeTime = ' + this.fadeSelect.fade_in);
      }
      const fadeOutTimeAux = this.fadeTimes.find(fadeTime => fadeTime.fadeTime === parseInt(this.fadeSelect.fade_out));
      if (fadeOutTimeAux) {
        this.selectedFadeOutTimeNominalValue = fadeOutTimeAux.nominalValue;
      } else {
        console.error('No se encontró ninguna coincidencia con fadeTime = ' + this.fadeSelect.fade_out);
      }
    }
  }

  changeFadeOfLumaria(luminaria) {
    let fade = '';
    if (this.fadeSelect == undefined) {
      fade = '-1';
    } else {
      fade = this.fadeSelect.id;
    }
    luminaria.idFade = fade;
    this.luminariaService.addFadeToLuminaria(luminaria.idDispositivo, fade).subscribe(result => { });
  }

  loadLuminarias() {
    this.luminarias = this.luminariasReal;
    if (this.planoSelected != undefined)
      this.luminarias = this.luminariasReal.filter(luminaria => luminaria.idPlano == this.planoSelected.idPlano)
    if (this.grupoSelected != undefined)
      this.luminarias = this.luminariasReal.filter(luminaria =>
        this.grupoSelected.luminariaList.find(lumGrupo => lumGrupo == luminaria.idDispositivo)
        && luminaria.idConcentradorPpal == this.grupoSelected.idConcentrador);
    this.luminarias = this.luminarias.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));
  }

  selectPlano(event) {
    if (event.value == 'all') {
      this.planoSelected = undefined;
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == event.value.idPlano);
    }
    this.loadLuminarias();
  }

  selectGrupo(event) {
    if (event.value == 'all') {
      this.grupoSelected = undefined;
    } else {
      this.grupoSelected = this.grupos.find(grupo => grupo.idGrupo == event.value.idGrupo && grupo.idConcentrador == event.value.idConcentrador);
    }
    this.loadLuminarias();
  }

  fadeNombreById(idFade) {
    let fade = this.fades.find(fade => fade.id == idFade);
    if (fade == undefined) {
      return "Not assigned";
    }
    return fade.nombre
  }

  grupoNombreByIdAndIdConcentrador(idGrupo, idConcentrador) {
    return this.grupos.find(grupo => grupo.idGrupo == idGrupo && grupo.idConcentrador == idConcentrador).nombre;
  }

  toLocations() {
    this.navigation.toLocations();
  }

  getFadeTimes() {
    this.fadeTimesService.getFadeTimes().subscribe(result => {
      this.fadeTimes = <Array<fadeTime>> result;
    });
  }
}
